/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Rows_FailedInputs */

const en_import_rows_failed = /** @type {(inputs: Import_Rows_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows refused`)
};

/**
* | output |
* | --- |
* | "Rows refused" |
*
* @param {Import_Rows_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const import_rows_failed = /** @type {((inputs?: Import_Rows_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Rows_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_import_rows_failed(inputs)
});